import EventBoat from '@model/EventBoat'
import EventRace from '@model/EventRace'
import { Model } from 'pinia-orm'
import { BelongsTo, Num, Str, Uid } from 'pinia-orm/decorators'

export default class EventBoatRace extends Model {
	static entity = 'events-boats-races'

	@Uid() declare id: string
	@Uid() declare eventBoatId: string
	@BelongsTo( () => EventBoat, 'eventBoatId' ) declare eventBoat: EventBoat
	@Str( null ) declare eventRaceId: string | null
	@BelongsTo( () => EventRace, 'eventRaceId' ) declare eventRace: EventRace | null
	@Str( null ) declare handicapSelected: string | null
	@Num( null ) declare handicapValue: number | null

	get dump () {
		return {
			eventRaceId: this.eventRaceId,
			handicapSelected: this.handicapSelected,
			handicapValue: this.handicapValue,
		}
	}

	static piniaOptions = {
		persist: true
	}
}
